import styled from 'styled-components';

export const StyledChartCard = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  box-shadow: 0px 0px 6px 0px #00000026;
  background-color: white;
  border-radius: 10px;

  .chart-card {
    &.sm {
      border-radius: 10px;
      padding: 12px 20px;
      max-height: 21vh;
      height: 100%;
      .chart-card-header {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        &-title {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          margin-bottom: 14px;

          .title {
            color: #2f2f35;
            font-family: Poppins, sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
          }

          .icon {
            display: none;
            width: 24px;
            height: 24px;
            flex-shrink: 0;
          }
        }

        &-content {
          height: 35px;
          border-radius: 4px;
          padding: 5px 11px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #2f2f35;
          font-family: Poppins, sans-serif;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          background-color: ${(props) =>
            props.bgColor
              ? 'rgba(' + props.bgColor.r + ',' + props.bgColor.g + ',' + props.bgColor.b + ',0.15)'
              : 'white'};
          overflow: revert;
          max-lines: 1;
        }
      }

      .chart-card-content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        align-self: center;
        height: ${(props) => (props.isHeader ? '85%' : '100%')};

        .before {
          flex-grow: 1;
        }

        .chart {
          flex-grow: 1;
        }

        .after {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          overflow-y: scroll;
          height: 100%;
        }
      }
    }

    &.md,
    &.lg {
      padding: 25px 35px;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
      height: 100%;

      .chart-card-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;

        &-title {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;

          .title {
            color: #2f2f35;
            font-family: Poppins, sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            margin-right: 8px;
          }

          .icon {
            width: 24px;
            height: 24px;
            flex-shrink: 0;
          }
        }

        &-content {
          height: 35px;
          border-radius: 4px;
          padding: 5px 11px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #2f2f35;
          font-family: Poppins, sans-serif;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          background-color: ${(props) =>
            props.bgColor
              ? 'rgba(' + props.bgColor.r + ',' + props.bgColor.g + ',' + props.bgColor.b + ',0.15)'
              : 'white'};
          overflow: revert;
          max-lines: 1;
        }
      }

      &-content {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 90%;

        &-line {
          width: 100%;
        }
      }
    }
  }
`;
